import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../store/AppStore'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import { connect } from 'react-redux'
import AutocompleteList from './AutocompleteList'
import DtoCity from '../../referential/dto/DtoCity'
import DtoWatershed from '../../referential/dto/DtoWatershed'
import ResearchTypes from '../../utils/ResearchTypes'
import DtoSimpleStation from '../../referential/dto/DtoSimpleStation'
import DtoManagementWater from '../../referential/dto/DtoManagementWater'
import i18n from 'simple-react-i18n'
import { find, flattenDeep, uniq } from 'lodash'
import SiteTypes from '../../utils/mapUtils/SiteTypes'
import ReactTimeout from 'react-timeout'
import { filterList } from '../../utils/FilterUtils'
import DtoStation from '../../sites/dto/DtoStation'
import DtoDepartment from '../../referential/dto/DtoDepartment'

const WAIT_INTERVAL = 500

class AutoComplete extends Component {

	constructor(props) {
		super(props)
		this.state = {
			filterEntry: ''
		}
	}

	removeEntry = () => {
		this.setState({ filterEntry: '' })
	}

	handleChange = e => {
		this.props.setTimeout(this.setState({ filterEntry: e.target.value }), WAIT_INTERVAL)
	}

	getCitiesRef = () => {
		return filterList(this.props.cities, this.state.filterEntry, this.props.cities.length).map((o) => {
			const postalCode = o.postalCode ? o.postalCode : o.code
			return {
				label: '[' + o.code + '] - ' + o.name + ' - ' + postalCode,
				value: o
			}
		})
	}
	getDepartmentsRef = () => {
		return filterList(this.props.departments, this.state.filterEntry, this.props.cities.length).map((o) => {
			const code = o.code ? '[' + o.code + ']' : ''
			return {
				label: code + ' - ' + o.name,
				value: o
			}
		})
	}

	getWaterShedRef = () => {
		return filterList(this.props.watersheds, this.state.filterEntry, this.props.cities.length).map((o) => {
			const code = o.code ? '[' + o.code + ']' : ''
			return {
				label: code + ' - ' + o.name,
				value: o
			}
		})
	}

	getManagementWaterRef = () => {
		return filterList(this.props.managementWaters, this.state.filterEntry, this.props.cities.length).map((o) => {
			const code = o.code ? '[' + o.code + ']' : ''
			return {
				label: code + ' - ' + o.name,
				value: o
			}
		})
	}

	getStationRef = () => {
		const selectedTypes = uniq(flattenDeep(this.props.selectedThemes.map(t => {
			return t.value.siteTypes.map(o => o.type)
		})))
		return filterList(this.props.stations, this.state.filterEntry, this.props.cities.length).filter(o => {
			if (o.isPiezometer === '1' && o.isQualitometer === '1') {
				return find(selectedTypes, t => t === SiteTypes.PIEZOMETER.type || t === SiteTypes.QUALITOMETER.type)
			}
			return find(selectedTypes, t => t === o.typeParameter)
		}).map(o => {
			const code = o.code ? '[' + o.code + ']' : ''
			return {
				label: code + ' - ' + o.name,
				value: o
			}
		})
	}

	componentWillUnmount() {
		AppStore.dispatch(AdministrationAction.resetEntry())
	}

	getFilterResult = () => {
		if (this.state.filterEntry.length >= 3) {
			const minWidth = (() => {
				if (this.props.isResearchMap) {
					return '60vw'
				}
				return '1280px'
			})()
			const justifyContent = (() => {
				if (this.props.isResearchMap) {
					return 'flex-start'
				}
				return 'center'
			})()
			const style = {
				zIndex: 1000,
				position: 'absolute',
				minWidth: minWidth,
				maxWidth: '80vw',
				margin: '3.5rem auto 0',
				right: 0,
				left: 0
			}
			const moreStyle = {
				borderRadius: '2px',
				overflow: 'hidden',
				display: 'flex',
				justifyContent: justifyContent,
				flexWrap: 'wrap'
			}
			return (
				<div className='col s12 no-padding' style={ style }>
					<div className='row no-margin' style={ moreStyle }>
						<AutocompleteList key={ 'city' } list={ this.getCitiesRef() } type={ ResearchTypes.CITY }
										  isFirst icon='location_city' isResearchMap={ this.props.isResearchMap }
										  singularTitle={ i18n.town } plurialTitle={ i18n.towns }
										  removeEntry={ this.removeEntry }/>
						<AutocompleteList key={ 'watershed' } list={ this.getWaterShedRef() }
										  type={ ResearchTypes.WATERSHED } isMiddle icon='texture'
										  isResearchMap={ this.props.isResearchMap }
										  singularTitle={ i18n.watershedArea } plurialTitle={ i18n.watersheds }
										  removeEntry={ this.removeEntry }/>
						<AutocompleteList key={ 'stations' } list={ this.getStationRef() }
										  type={ ResearchTypes.STATION } isMiddle
										  icon='location_on' isResearchMap={ this.props.isResearchMap }
										  singularTitle={ i18n.station } plurialTitle={ i18n.stations }
										  removeEntry={ this.removeEntry }/>
						<AutocompleteList key={ 'departments' } list={ this.getDepartmentsRef() }
										  type={ ResearchTypes.DEPARTMENT } isEnd
										  icon='location_on' isResearchMap={ this.props.isResearchMap }
										  singularTitle={ i18n.department } plurialTitle={ i18n.departments }
										  removeEntry={ this.removeEntry }/>
					</div>
				</div>
			)
		}
		return null
	}

	render() {
		return (
			<div className='row no-margin'>
				<div className='input-field col s12 no-margin'>
					<input ref='filterInput' id='research' type='text'
						   className='no-margin validate input-research-input'
						   onChange={ this.handleChange }
						   defaultValue={ this.state.filterEntry }
						   value={ this.state.filterEntry }
						   placeholder={ i18n.geographicalCriteriaResearch }/>
					<label htmlFor='research'/>
				</div>
				{ this.getFilterResult() }
			</div>
		)
	}
}

AutoComplete.propTypes = {
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	isResearchMap: PropTypes.bool,
	cities: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity)),
	departments: PropTypes.arrayOf(PropTypes.instanceOf(DtoDepartment)),
	watersheds: PropTypes.arrayOf(PropTypes.instanceOf(DtoWatershed)),
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoSimpleStation)),
	managementWaters: PropTypes.arrayOf(PropTypes.instanceOf(DtoManagementWater)),
	selectedThemes: PropTypes.arrayOf(PropTypes.object),
	setTimeout: PropTypes.func,
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation))
}
const mapStateToProps = store => {
	return {
		selectedFilters: store.AdministrationReducer.selectedFilters,
		cities: store.ReferentialReducer.cities,
		departments: store.ReferentialReducer.departments,
		watersheds: store.ReferentialReducer.watersheds,
		managementWaters: store.ReferentialReducer.managementWaters,
		stations: store.ReferentialReducer.stations,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		selectedStations: store.SitesReducer.selectedStations
	}
}

const autoCompleteTimeOut = ReactTimeout(AutoComplete)

export default connect(mapStateToProps)(autoCompleteTimeOut)



// WEBPACK FOOTER //
// ./src/components/autocompleteChips/AutoComplete.js